module.exports = __webpack_public_path__ + "static/media/treatment.5388fb40.jpg";